// extracted by mini-css-extract-plugin
export var orderSummary = "_rh-0";
export var showMoreLessButton = "_rh-1";